import { render, staticRenderFns } from "./ModalCodeError.vue?vue&type=template&id=f5189086"
import script from "./ModalCodeError.vue?vue&type=script&lang=js"
export * from "./ModalCodeError.vue?vue&type=script&lang=js"
import style0 from "./ModalCodeError.vue?vue&type=style&index=0&id=f5189086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports